import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { EquipoTecnologico } from 'src/app/shared/models/equipo-tecnologico.interface';
import { EquipoTecnologicoService } from 'src/app/pages/services/equipo-tecnologico.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lista-equipos-tecnologicos',
  templateUrl: './lista-equipos-tecnologicos.component.html',
  styleUrls: ['./lista-equipos-tecnologicos.component.css']
})
export class ListaEquiposTecnologicosComponent implements OnInit, OnChanges {

  @Input() equipos_List!: EquipoTecnologico[];
  @Output() onDebounce: EventEmitter<boolean> = new EventEmitter();
  @Output() editar: EventEmitter<EquipoTecnologico> = new EventEmitter();
  debouncer: Subject<boolean> = new Subject();
  buscadorDebouncer: Subject<string> = new Subject();

  textoBusqueda: string = '';

  displayedColumns: string[] = ['tipo', 'marca', 'modelo', 'chip', 'numeroSerie', 'estado', 'accesorios', 'observacion', 'actions'];
  dataSource = new MatTableDataSource<EquipoTecnologico>(this.equipos_List);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private alert: AlertHelper,
    private equipoTecnologicoService: EquipoTecnologicoService
  ) { }

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(500))
      .subscribe(valor => {
        this.onDebounce.emit(valor);
      });

    this.buscadorDebouncer
      .pipe(debounceTime(500))
      .subscribe(texto => {
        this.buscar(texto);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.equipos_List != undefined) {
      if (!changes.equipos_List.firstChange) {
        this.dataSource = new MatTableDataSource<EquipoTecnologico>(this.equipos_List);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
  }

  onBuscar(event: Event) {
    const texto = (event.target as HTMLInputElement).value;
    this.buscadorDebouncer.next(texto);
  }

  buscar(texto: string) {
    if (!texto || texto.trim().length === 0) {
      this.equipoTecnologicoService.traerEquipos().subscribe(res => {
        this.dataSource = new MatTableDataSource<EquipoTecnologico>(res.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    } else {
      this.equipoTecnologicoService.buscarEquipos(texto.trim()).subscribe(res => {
        this.dataSource = new MatTableDataSource<EquipoTecnologico>(res.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    }
  }

  editarEquipo(equipo: EquipoTecnologico) {
    this.editar.emit(equipo);
  }

  darDeBaja(id: number) {
    Swal.fire({
      title: 'Dar de baja?',
      text: "El equipo seleccionado pasará a estado DE_BAJA",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      cancelButtonColor: '#6c736e',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Dar de baja'
    }).then((result) => {
      if (result.isConfirmed) {

        this.equipoTecnologicoService.actualizarEstadoEquipo(id, 'DE_BAJA').subscribe(res => {
          if (res.success == true) {
            this.alert.success_small(res.msg!)
            this.debouncer.next(true);
          } else {
            this.alert.error_small(res.msg!)
          }
        })
      }
    })
  }

}
